<template>
  <v-container fluid grid-list-lg>
    <v-layout row wrap>
      <v-flex xs12 sm8 offset-sm2 pt-5>
        <v-alert :value="true" v-if="error != null" type="error">{{
          error.message
        }}</v-alert>
        <v-alert :value="true" v-if="success != null" type="success">{{
          success.message
        }}</v-alert>

        <v-alert :value="true" v-if="showCRMError === true" type="warning">
          We were unable to obtain your latest preferences. Please try again later.
        </v-alert>

        <v-layout justify-center column>
          <template v-if="ready">
            <v-form
              ref="form"
              v-model="valid"
              lazy-validation
              @submit.prevent="updateUser"
            >
              <h2 class="heading-2 align-left">Sign For Celtic</h2>

              <h2 class="heading-3 align-left">Club Communications</h2>
              <div class="body-copy">
                <p>
                  Stay up to date with the latest news, offers and competitions
                  from Celtic Park. Includes Celtic FC Foundation and Celtic
                  Pools updates.
                </p>
              </div>

              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch :label="`Email`" v-model="clubEmail"></v-switch>
                </v-flex>
              </v-layout>

              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch :label="`SMS`" v-model="clubSMS"></v-switch>
                </v-flex>
              </v-layout>

              <!--<v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch
                  :label="`Mail`"
                  v-model="clubDirect"
                  ></v-switch>
                </v-flex>
              </v-layout>-->

              <!--<v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch
                  :label="`Phone`"
                  v-model="clubPhone"
                  ></v-switch>
                </v-flex>
              </v-layout>-->

              <!--<v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch
                  :label="`Digital Ads`"
                  v-model="clubAds"
                  ></v-switch>
                </v-flex>
              </v-layout>-->

              <div v-if="configValues.communitySchemeMarketingEnabled === true">
                <h2 class="heading-3 align-left">
                  {{ configValues.communityScheme.name }} News
                </h2>
                <div class="body-copy">
                  <p>
                    Keep me updated by email with the latest news from
                    {{ configValues.communityScheme.name }} including
                    fundraising events.
                  </p>
                </div>
                <v-layout row class="border-bottom">
                  <v-flex xs12>
                    <v-switch
                      :label="`Email`"
                      v-model="foundationEmail"
                    ></v-switch>
                  </v-flex>
                </v-layout>
              </div>

              <h2 class="heading-3 align-left">Partner Communications</h2>
              <div class="body-copy">
                <p>
                  Receive occasional messages from our partners. A full list is
                  available
                  <a
                    href="https://www.celticfc.com/club/club-partners"
                    target="_blank"
                    >here</a
                  >. These may change over time. Celtic FC will NOT pass your
                  data to any partners.
                </p>
              </div>

              <v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch :label="`Email`" v-model="partnerEmail"></v-switch>
                </v-flex>
              </v-layout>

              <v-layout row >
                <v-flex xs12>
              <h2 class="heading-3 align-left">Interests</h2>
              <div class="body-copy">
                <p>Please let us know your interests.</p>
              </div>
                </v-flex>
              </v-layout>

              <v-layout row >
                <v-flex xs4 sm4> Who are your favourite players?
                  <p>
                    <br /> You can select up to 3 players across our men's, women's and legends' squads.
                  </p>
                  </v-flex>
                <v-flex xs3 sm3>
                  <v-select
                    :hide-details="true"
                    label="Select Squad"
                    :items="squads"
                    v-model="selectedSquad"
                    item-value="name"
                    outline
                  >
                    <template slot="selection" slot-scope="data">
                      <!-- HTML that describe how select should render selected items -->
                      {{ data.item.name }}
                    </template>
                    <template slot="item" slot-scope="data">
                      <!-- HTML that describe how select should render items when the select is open -->
                      {{ data.item.name }}
                    </template>
                  </v-select>
                </v-flex>
              <v-flex xs3 sm3>

                  <v-select
                    v-if="selectedSquad != null"
                    :hide-details="true"
                    label="Select Player"
                    :items="players"
                    v-model="selectedPlayer"
                    item-value="name"
                    outline
                    required
                  >
                    <template slot="selection" slot-scope="data">
                      <!-- HTML that describe how select should render selected items -->
                      {{ data.item.name }}
                    </template>
                    <template slot="item" slot-scope="data">
                      <!-- HTML that describe how select should render items when the select is open -->
                      {{ data.item.number }} {{ data.item.name }}
                    </template>
                  </v-select>
              </v-flex>
              <v-flex xs2 sm2>
                  <v-btn
                    icon
                    @click="addFavPlayer"
                    v-if="selectedPlayer != null"
                  >
                    <v-icon color="white">add</v-icon>
                  </v-btn>
                </v-flex>
                
              </v-layout>
              <v-layout row class="border-bottom">
                <v-flex xs4 sm4>
                </v-flex>
                <v-flex xs8 sm8>
                  <v-list>
                    <v-list-group
                      v-if="favPlayers.length"
                      v-model="playerListOpen"
                      append-icon=""
                    >
                      <v-list-tile
                        v-for="(player, index) in favPlayers"
                        :key="index"
                      >
                        <v-list-tile-content>
                          {{ player }}
                        </v-list-tile-content>
                        <v-list-tile-action>
                          <v-btn icon @click="deleteFavPlayer(player)">
                            <v-icon color="white">delete</v-icon>
                          </v-btn>
                        </v-list-tile-action>
                      </v-list-tile>
                    </v-list-group>
                    <v-list-tile v-else>
                      <v-list-tile-content></v-list-tile-content>
                    </v-list-tile>
                  </v-list>
                </v-flex>
              </v-layout>

              <v-layout row class="border-bottom">
                <v-flex xs12 sm4>
                  Who do you attend matches at Celtic Park with?
                </v-flex>
                <v-flex xs12 sm8>
                  <v-select
                    :hide-details="true"
                    label="Please select"
                    :items="metaAttendWithOptions"
                    v-model="metaAttendWithSelected"
                    outline
                    required
                  ></v-select>
                </v-flex>
              </v-layout>
              <v-layout row class="border-bottom">
                <v-flex xs12 sm4>
                  Do you have children who play football?
                </v-flex>
                <v-flex xs12 sm8>
                  <v-select
                    :hide-details="true"
                    label="Please select"
                    :items="metaChildrenPlayOptions"
                    v-model="metaChildrenPlaySelected"
                    outline
                    required
                  ></v-select>
                  
                </v-flex>
              </v-layout>
              <v-layout row class="border-bottom">
                <v-flex xs12 sm4>
                  Which official Celtic FC products are you interested in?
                </v-flex>
                <v-flex xs12 sm8>
                  <v-checkbox v-for="(option, index) in metaProductInterestOptions"
                        :key="index"
                    v-model="metaProductInterestSelected"
                    :label="option"
                    :value="option"
                  ></v-checkbox>
                
                
                </v-flex>
              </v-layout>
              <v-layout row class="border-bottom">
                <v-flex xs12 sm4>
                  Which teams are most interested in?
                </v-flex>
                <v-flex xs12 sm8>
                  <v-checkbox v-for="(option, index) in metaTeamInterestOptions"
                        :key="index"
                    v-model="metaTeamInterestSelected"
                    :label="option"
                    :value="option"
                  ></v-checkbox>
                
                  
                </v-flex>
              </v-layout>
              <v-layout row class="border-bottom">
                <v-flex xs12 sm4>
                  What types of holidays are you interested in?
                </v-flex>
                <v-flex  xs12 sm8 >
                  <v-checkbox v-for="(option, index) in metaHolidayInterestOptions"
                        :key="index"
                    v-model="metaHolidayInterestSelected"
                    :label="option"
                    :value="option"
                  ></v-checkbox>
                
                 
                </v-flex>
              </v-layout>
              
      

              <!--<v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch
                  :label="`SMS`"
                  v-model="partnerSMS"
                  ></v-switch>
                </v-flex>
              </v-layout>-->

              <!--<v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch
                  :label="`Phone`"
                  v-model="partnerPhone"
                  ></v-switch>
                </v-flex>
              </v-layout>-->

              <!--<v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch
                  :label="`Mail`"
                  v-model="partnerDirect"
                  ></v-switch>
                </v-flex>
              </v-layout>-->

              <!--<v-layout row class="border-bottom">
                <v-flex xs12>
                  <v-switch
                  :label="`Digital Ads`"
                  v-model="partnerAds"
                  ></v-switch>
                </v-flex>
              </v-layout>-->
              <!-- <div class="body-copy">
                <p><a :href="configStrings.clubPrivacyPolicyLink" target="_blank">Click here</a> to see our current list of Partners / Sponsors. Our Partners change regularly, so we update this list at least once every season.</p>
              </div>-->
              <v-layout row align-center mx-1 mt-5>
                <v-spacer />
                <button
                  type="submit"
                  class="button"
                  :disabled="!valid || !ready"
                >
                  Update
                </button>
              </v-layout>
            </v-form>
          </template>
          <template v-else-if="showCRMError === true"> 
          </template>
          <template v-else>
            <div class="text-xs-center">
              <v-progress-circular
                :size="50"
                color="accent"
                indeterminate
              ></v-progress-circular>
            </div>
          </template>
        </v-layout>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
export default {
  name: "UserProfileContactPrefs",
  data() {
    return {
      ready: false,
      valid: true,
      ssoid: "",
      //clubAds: false,
      clubEmail: false,
      clubSMS: false,
      clubPhone: false,
      clubDirect: false,
      partnerEmail: false,
      partnerSMS: false,
      partnerPhone: false,
      partnerDirect: false,
      //partnerAds: false,
      squads: [],
      players: [],
      playerListOpen: true,
      selectedSquad: null,
      selectedPlayer: null,
      favPlayers: [],
      foundationEmail: false,
      error: null,
      success: null,
      loading: false,
      showCRMError: false,
      metaAttendWithOptions: [ 'With my children/grandchildren', 'With other family members', 'I don\'t attend matches at Celtic Park'],
      metaAttendWithSelected: null,
      metaChildrenPlayOptions: [  'Yes, my daughter(s)', 'Yes, my son(s)', 'Yes, my son(s) and daughter(s)', 'No, I don\'t have children who play football'],
      metaChildrenPlaySelected: null,
      metaProductInterestOptions: [  'Kits', 'Training wear', 'Casual clothing', 'adidas collections'],
      metaProductInterestSelected: [],
      metaTeamInterestOptions: [ 'Men\'s', 'Women\'s'],
      metaTeamInterestSelected: [],
      metaHolidayInterestOptions: [ 'Activity', 'Cruise', 'Fly & Drive', 'Luxury', 'Staycation', 'Winter Sport', 'City'],
      metaHolidayInterestSelected: [],
    };
  },
  created() {
    var vm = this;

    // load this user's latest information
    this.$getCurrentUserAttributes().subscribe((userData) => {
      vm.ssoid = userData["sub"];
      if(typeof userData["custom:metadata"] !== 'undefined'){
        var metadata = JSON.parse(userData["custom:metadata"])
        vm.favPlayers = metadata["fav_players"]
        vm.metaAttendWithSelected =  metadata["attend_with"]
        vm.metaChildrenPlaySelected = metadata["children_play"]
        vm.metaProductInterestSelected = metadata["products"]
        vm.metaTeamInterestSelected = metadata["teams"]
        vm.metaHolidayInterestSelected = metadata["holidays"]
      }
      vm.getExternalContactPreferences(userData["sub"]).then(function (
        response
      ) {
        if (response === null) {
          // if the function didn't pass back any preferences
          console.log("No external preferences, so using SSO values");
          vm.clubEmail = userData["custom:club_email"] == "true" ? true : false;
          vm.clubSMS = userData["custom:club_sms"] == "true" ? true : false;
          vm.clubPhone = userData["custom:club_phone"] == "true" ? true : false;
          vm.clubDirect =
            userData["custom:club_direct"] == "true" ? true : false;
          vm.partnerEmail =
            userData["custom:partner_email"] == "true" ? true : false;
          vm.partnerSMS =
            userData["custom:partner_sms"] == "true" ? true : false;
          vm.partnerPhone =
            userData["custom:partner_phone"] == "true" ? true : false;
          vm.partnerDirect =
            userData["custom:partner_direct"] == "true" ? true : false;
          // vm.clubAds = ((userData['custom:club_ads'] == "true" ) ? true : false )
          vm.foundationEmail =
            userData["custom:foundation_email"] == "true" ? true : false;
          // vm.partnerAds = ((userData['custom:partner_ads'] == "true" ) ? true : false )
        } else {
          // if we did get preferences (set them)
          console.log(
            "TODO: set local preferences to values from external system"
          );
          console.log("External data received", response);
          vm.clubEmail = response.clubEmail;
          vm.clubSMS = response.clubSMS;
          vm.clubPhone = response.clubPhone;
          vm.clubDirect = response.clubDirect;
          vm.partnerEmail = response.partnerEmail;
          vm.partnerSMS = response.partnerSMS;
          vm.partnerPhone = response.partnerPhone;
          vm.partnerDirect = response.partnerDirect;

        }

        fetch("/squads.json")
          .then((r) => r.json())
          .then(
            (json) => {
              vm.squads = json.squads;
              console.log("squads", vm.squads);
            },
            (response) => {
              console.log("Error loading json:", response);
            }
          );

        // tell the app that we've finished loading
        vm.ready = true;
      })
      .catch(function(error) {
        // Handle the rejected promise (error)
        console.error('Error occurred while retrieving preferences:', error.message);
        // You can choose to reject the outer promise or handle it differently based on your needs
        vm.showCRMError = true;
      });
    });
  },
  watch: {
    selectedSquad: function (val, oldVal) {
      var thisSquad = this.squads.find((squad) => squad.name === val);
      this.players = thisSquad.players;
    },
  },
  methods: {
    complete(username) {
      console.log("completing");
      var vm = this;
      this.dataPush(username).then(function (results) {
        vm.error = null;
        var response = {
          message: "Your contact preferences have been updated successfully.",
        };
        vm.success = response;
        vm.ready = true;
      });
    },
    deleteFavPlayer(player) {
      console.log("Deleting player", player);
      this.favPlayers = this.favPlayers.filter((e) => e !== player);
    },
    addFavPlayer() {
      console.log("Adding player", this.selectedPlayer);
      if (this.favPlayers.length > 2) {
        console.log("Player list oif full");
      } else if (this.favPlayers.includes(this.selectedPlayer)) {
        console.log("Player already in fav list");
      } else {
        this.favPlayers.push(this.selectedPlayer);
        this.selectedPlayer = null
      }
      console.log("Fav players", this.favPlayers);
    },
    updateUser(e) {
      e.preventDefault();
      this.ready = false;

      var clubEmail = this.clubEmail.toString();
      var clubSMS = this.clubSMS.toString();
      var clubPhone = this.clubPhone.toString();
      var clubDirect = this.clubDirect.toString();
      //var clubAds = this.clubAds.toString();
      //var foundationEmail = this.foundationEmail.toString();
      var partnerEmail = this.partnerEmail.toString();
      var partnerSMS = this.partnerSMS.toString();
      var partnerPhone = this.partnerPhone.toString();
      var partnerDirect = this.partnerDirect.toString();
      //var partnerAds = this.partnerAds.toString();

      var attributesList = {
        "custom:club_email": clubEmail,
        "custom:club_sms": clubSMS,
        "custom:club_phone": clubPhone,
        "custom:club_direct": clubDirect,
        //"custom:club_ads": clubAds,
        //"custom:foundation_email": foundationEmail,
        "custom:partner_email": partnerEmail,
        "custom:partner_sms": partnerSMS,
        "custom:partner_phone": partnerPhone,
        "custom:partner_direct": partnerDirect,
        //"custom:partner_ads": partnerAds
        "custom:metadata": JSON.stringify({
          "fav_players": this.favPlayers,
          "attend_with": this.metaAttendWithSelected,
          "children_play": this.metaChildrenPlaySelected,
          "products": this.metaProductInterestSelected,
          "teams": this.metaTeamInterestSelected,
          "holidays": this.metaHolidayInterestSelected,
        })
      };
      var vm = this;
      this.$updateAttributes(attributesList).subscribe(
        (response) => {
          console.log("update successful");
          vm.complete(vm.ssoid);
        },
        (err) => {
          //if we get an UnkownError it is more than likely because the user has a status of 'FORCE_CHANGE_PASSWORD' in AWS Cognito
          console.log(err.message);
          vm.success = null;
          vm.error = err;
          vm.ready = true;
        }
      );
    },
  },
};
</script>

<style scoped>
.border-bottom {
  border-bottom: 1px solid #eeeeee;
}
.heading-3 {
  padding-top: 30px;
}
.favPlayer {
  display: block;
}
a{
  color: green;
}
</style>